import './Card.css';

/**
 * #124 — Container/card canônico (branco, radius 16px, sombra sutil).
 * Passa className e props nativos adiante.
 */
export default function Card({ children, className = '', ...rest }) {
  return (
    <div className={`ui-card${className ? ' ' + className : ''}`} {...rest}>
      {children}
    </div>
  );
}
